import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
export const vmDashboardDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.exportVmData',
        popover: {
          title: 'Export VM Data',
          description:
            'Use this option to export data related to your virtual machines. This is useful for generating reports or performing detailed analysis on your VMs.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.vmRelatedInfo',
        popover: {
          title: 'VM Related Information',
          description:
            'This section provides detailed information about the virtual machines, including their status, performance metrics, and configurations.',
          side: 'left',
          align: 'start',
        },
      },
    ],
  });
  return driverObj;
};
export default vmDashboardDriverObj;
